import { authFetch } from './client';

/**
 * Submit a bug report. `screenshots` is an array of
 *   { filename, contentType, dataBase64 }
 * objects. `context` is { url, projectId?, userAgent }.
 */
export async function submitBugReport({ title, description, screenshots, context }) {
  return authFetch('/api/bug-reports', {
    method: 'POST',
    body: JSON.stringify({ title, description, screenshots, context }),
  });
}
